export default __webpack_public_path__ + "3a70699010a95c33e456bc54c773ea34.png";